import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDepartmentDetailFind = createAsyncThunk(
  "fetchDepartmentDetailFind",
  async ({ id }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };

    const response = await axiosHttp.get(
      `department/detail?id=${id}`,
      config
    );
    
    return response.data.data;
  }
);

const departmentDetailFindSlice = createSlice({
  name: "departmentDetailFind",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
 
  reducers: {
    resetStateDepartmentDetailFind: (state) => {
      state.isLoading = false;
      state.error = null;
      state.data = null;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(fetchDepartmentDetailFind.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchDepartmentDetailFind.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;

    });
    builder.addCase(fetchDepartmentDetailFind.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { resetStateDepartmentDetailFind } = departmentDetailFindSlice.actions;
export default departmentDetailFindSlice.reducer;